// Techfare's cut of every sale, plus what each payment processor charges the seller.
// Sellers are the merchant on both PayPal and Stripe, so the processor fee comes out
// of their side of the sale; Techfare's fee is split off at checkout.
export const PLATFORM_FEE_RATE = 0.06;
export const PAYPAL_FEE_RATE = 0.0349;
export const PAYPAL_FIXED_FEE = 0.49;
export const STRIPE_FEE_RATE = 0.029;
export const STRIPE_FIXED_FEE = 0.3;
export const SHIPPING_FEE = 0;

export type PayoutMethod = "paypal" | "stripe";

export const PAYOUT_METHOD_LABELS: Record<PayoutMethod, string> = {
  paypal: "PayPal",
  stripe: "Stripe",
};

function roundCurrency(value: number) {
  return Math.round(value * 100) / 100;
}

export function getPlatformFee(amount: number) {
  return amount > 0 ? roundCurrency(amount * PLATFORM_FEE_RATE) : 0;
}

export function getProcessingFee(amount: number, method: PayoutMethod = "paypal") {
  if (amount <= 0) return 0;
  return method === "stripe"
    ? roundCurrency(amount * STRIPE_FEE_RATE + STRIPE_FIXED_FEE)
    : roundCurrency(amount * PAYPAL_FEE_RATE + PAYPAL_FIXED_FEE);
}

/**
 * What the seller keeps from a sale. Without a method it assumes PayPal, the
 * pricier processor, so the estimate never promises more than a sale pays.
 */
export function getSellerPayoutBreakdown(askingPrice: number, method: PayoutMethod = "paypal") {
  const platformFee = getPlatformFee(askingPrice);
  const processingFee = getProcessingFee(askingPrice, method);
  const shippingFee = roundCurrency(SHIPPING_FEE);
  const payout = roundCurrency(Math.max(0, askingPrice - platformFee - processingFee - shippingFee));

  return { platformFee, processingFee, shippingFee, payout };
}
